import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../../../shared/shared.module';
import { AddressModule } from '../../address/address.module';
import { DescriptionModule } from '../description.module';
import { EditDescriptionComponent } from './edit-description.component';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    AddressModule,
    DescriptionModule,
  ],
  declarations: [EditDescriptionComponent],
  exports: [EditDescriptionComponent],
})
export class EditDescriptionModule {}
